module.exports = __webpack_public_path__ + "img/softwareOpen1.03dace34.png";